import { defineStore } from 'pinia'
import _ from 'lodash'
import { getAllPaymentUMAS } from '@/services/Sales'

export const usePaymentUMAStore = defineStore('paymentUMA', {
  state: () => ({
    paymentUMA: [],
  }),

  getters: {
    getPaymentUMAS: (state) => state.paymentUMA,
  },

  actions: {
    async get($fire = null) {
      try {
        // Si estás en un plugin de Nuxt que inyecta `$fire`, pásalo desde fuera o usa `useNuxtApp()` si estás en Nuxt 3.
        const result = await getAllPaymentUMAS($fire)
        const paymentUMA = []

        if (!result.empty) {
          result.forEach((doc) => {
            paymentUMA.push({ id: doc.id, ...doc.data() })
          })
        }

        this.paymentUMA = _.cloneDeep(paymentUMA)
      } catch (error) {
        // TODO: Handle Error
        console.log(error)
        throw new Error(error)
      }
    },
  },
})
